import { render, staticRenderFns } from "./organizationsTable.vue?vue&type=template&id=093f55f5&scoped=true&"
import script from "./organizationsTable.vue?vue&type=script&lang=js&"
export * from "./organizationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f55f5",
  null
  
)

export default component.exports